import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getAllCMS,
  createCMS,
  updateCMS,
  deleteCMS,
  getCMSByID,
  cmsActiveInactive,
} from "./cms.service";
import { ICMS, ICMSState } from "./cmsModel";

// Extend ICMSState if needed, or modify it in cmsModel.ts
// Looking at cmsSlice.ts, ICMSState is imported.

const initialState: ICMSState = {
  loading: false,
  error: "",
  CMSList: [],
  CMSID: null,
  DeleteImageIndex: 0,
  CMSDetail: {
    Name: "",
    CMSURL: "",
    Template: "",
    MetaDescription: "",
    MetaKeyword: "",
    MetaTitle: "",
    CMSImage: "",
    CMSImageAlterTag: "",
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteCMSID: null,
};

const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    clearCMSDetails: (state) => {
      state.CMSDetail = initialState.CMSDetail;
    },
    setCMSID: (state, action) => {
      state.CMSID = action.payload;
    },
    clearCMSID: (state) => {
      state.CMSID = initialState.CMSID;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.DeleteCMSID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteCMSID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCMS.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllCMS.fulfilled,
      (state, action: PayloadAction<ICMS[]>) => {
        state.loading = false;
        state.CMSList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(getAllCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CMSList = [];
    });

    builder.addCase(createCMS.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createCMS.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateCMS.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCMS.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getCMSByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCMSByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CMSDetail = action.payload;
    });
    builder.addCase(getCMSByID.rejected, (state, action) => {
      state.loading = false;
      state.CMSDetail = initialState.CMSDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteCMS.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCMS.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCMS.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(cmsActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(cmsActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(cmsActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearCMSDetails,
  setCMSID,
  clearCMSID,
  openDeleteModal,
  closeDeleteModal,
} = cmsSlice.actions;
export default cmsSlice.reducer;
